// extracted by mini-css-extract-plugin
module.exports = {"btnGreen":"styles_btnGreen__1R_7u","btnRed":"styles_btnRed__2ZLYI","container":"styles_container__20EXl"};